export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error)
  return (
    message.includes("Loading chunk") ||
    message.includes("Failed to load chunk") ||
    message.includes("ChunkLoadError") ||
    message.includes("Failed to fetch dynamically imported module")
  )
}

/**
 * Reload the page once to recover from a stale chunk.
 * Uses sessionStorage to prevent infinite reload loops.
 */
export function reloadOnChunkError(): void {
  const key = "chunk_error_reload"
  const lastReload = sessionStorage.getItem(key)
  if (lastReload && Date.now() - Number(lastReload) < 10_000) {
    return
  }
  sessionStorage.setItem(key, String(Date.now()))
  window.location.reload()
}
